import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUnLinked = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#4A5468"
      fillRule="evenodd"
      d="M12.399 3.577a1.97 1.97 0 0 0-2.787 0L7.795 5.395a.6.6 0 1 1-.849-.849l1.818-1.818a3.17 3.17 0 1 1 4.483 4.484L11.43 9.03a.6.6 0 1 1-.849-.849L12.4 6.364a1.97 1.97 0 0 0 0-2.787ZM5.37 6.97a.6.6 0 0 1 0 .848L3.557 9.634a1.97 1.97 0 0 0 2.786 2.786l1.815-1.814a.6.6 0 0 1 .848.849l-1.822 1.822A3.17 3.17 0 0 1 2.7 8.794l.005-.006 1.818-1.817a.6.6 0 0 1 .848 0Zm.146-4.164a.397.397 0 0 0-.369.426l.142 1.614c.02.217.216.379.439.36a.397.397 0 0 0 .369-.425l-.142-1.614a.404.404 0 0 0-.439-.36ZM2.8 5.326c-.021.22.14.415.36.437l1.703.172a.399.399 0 1 0 .079-.793L3.239 4.97a.4.4 0 0 0-.438.356Zm7.655 7.59a.396.396 0 0 0 .39-.408l-.062-1.618a.404.404 0 0 0-.42-.382.397.397 0 0 0-.39.407l.062 1.619a.404.404 0 0 0 .42.382m2.837-2.383a.4.4 0 0 0-.338-.454l-1.692-.256a.399.399 0 1 0-.117.788l1.692.256a.4.4 0 0 0 .455-.334"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgUnLinked;
